// export const navData = (state, data) => {
//   state.navMallAdv = data;
// }
export const unReadData = (state, data) => {
  state.unread = data;
}
export const Pop = (state, data) => {
  state.pop = data;
}



// WEBPACK FOOTER //
// ./src/store/mutations.js